import { Button } from '@cian/ui-kit/button';
import { IconActionChevronLeft24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './ModalHeaderBackable.css';
import { Header, IHeaderProps } from '../ModalHeader';

interface IHeaderBackableProps extends Omit<IHeaderProps, 'left'> {
  onBack(): void;
}

export const ModalHeaderBackable: React.FC<IHeaderBackableProps> = ({ onBack, ...sharedProps }) => {
  return (
    <Header
      {...sharedProps}
      left={
        <span className={styles['button']}>
          <Button
            theme="fill_white_primary"
            size="XS"
            beforeIcon={<IconActionChevronLeft24 display="block" />}
            onClick={onBack}
          />
        </span>
      }
    />
  );
};
